import { useContext } from 'react';
import { Flex, Text, Grid } from '@chakra-ui/react';
import { CheckIcon, LockIcon } from '@chakra-ui/icons';
import {
  ENTITLEMENT_CONFIG,
  getEntitlementValue,
  formatCountWithUnit,
} from './customPlanEntitlementsConfig';
import {
  unlockedFirst,
  columnMajorGridProps,
  newColumnStartProps,
} from '../../../utils/subscriptionUtils';
import { MeContext } from '../../../context/MeContext';

const GRID_COLUMNS = { base: 1, md: 2, lg: 3 };

const RequestedEntitlementsList = ({ requestedEntitlements, title }) => {
  const { state } = useContext(MeContext);
  const watermarkFree = state?.watermarkFree;
  const baseConfig = watermarkFree
    ? ENTITLEMENT_CONFIG.filter(({ key }) => key !== 'watermark')
    : ENTITLEMENT_CONFIG;

  const entitlements = baseConfig.map((config) => {
    const value = getEntitlementValue(requestedEntitlements, config.key);
    const hasValue =
      config.type === 'boolean'
        ? value === true
        : value !== undefined && value !== null;
    return { config, value, hasValue };
  });
  const orderedEntitlements = unlockedFirst(entitlements, (e) => e.hasValue);
  const firstLockedIndex = orderedEntitlements.findIndex((e) => !e.hasValue);

  return (
    <>
      {title && (
        <Text textStyle="bodyFamilySemiBold" fontSize="14px" mt={4} mb={2}>
          {title}
        </Text>
      )}
      <Grid
        {...columnMajorGridProps(orderedEntitlements.length, GRID_COLUMNS)}
        gap={{ base: 3, md: 4 }}
        my={6}
      >
        {orderedEntitlements.map(({ config, value, hasValue }, index) => {
          const { key, label, singularLabel, type } = config;

          return (
            <Flex
              key={key}
              alignItems="center"
              gap={2}
              borderRadius="12px"
              {...(index === firstLockedIndex
                ? newColumnStartProps(GRID_COLUMNS)
                : {})}
            >
              {hasValue ? (
                <Flex
                  align="center"
                  justify="center"
                  w="18px"
                  h="18px"
                  borderRadius="full"
                  bg="#FF4935"
                  color="white"
                  flexShrink={0}
                >
                  <CheckIcon boxSize={2} />
                </Flex>
              ) : (
                <LockIcon boxSize={4} color="grey" />
              )}
              <Flex gap={1}>
                {type === 'boolean' ? (
                  <Text textStyle="heading5" fontSize="14px">
                    {label}
                  </Text>
                ) : (
                  <Text textStyle="heading5" fontSize="14px">
                    {formatCountWithUnit(value, label, singularLabel)}
                  </Text>
                )}
              </Flex>
            </Flex>
          );
        })}
      </Grid>
    </>
  );
};

export default RequestedEntitlementsList;
